<cdk-virtual-scroll-viewport itemSize="50" class="example-viewport" (scrolledIndexChange)="indexChange($event)">
  <div *cdkVirtualFor="let item of items" class="example-item">{{ item || 'Loading...' }}</div>
</cdk-virtual-scroll-viewport>
